// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file settings_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyRequestSchema, EmptyResponseSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { Campaign } from "./campaign_pb";
import { file_campaign } from "./campaign_pb";
import type { Currency } from "./currency_pb";
import { file_currency } from "./currency_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file settings_service.proto.
 */
export const file_settings_service: GenFile = /*@__PURE__*/
  fileDesc("ChZzZXR0aW5nc19zZXJ2aWNlLnByb3RvEgtncnBjLmFwaS52MSI6Cg9DYW1wYWlnblJlcXVlc3QSJwoIY2FtcGFpZ24YASABKAsyFS5ncnBjLmFwaS52MS5DYW1wYWlnbiI7ChBDYW1wYWlnblJlc3BvbnNlEicKCGNhbXBhaWduGAEgASgLMhUuZ3JwYy5hcGkudjEuQ2FtcGFpZ24iOwoQQ3VycmVuY3lSZXNwb25zZRInCghjdXJyZW5jeRgBIAEoCzIVLmdycGMuYXBpLnYxLkN1cnJlbmN5IpABChdBY2NvdW50U2V0dGluZ3NSZXNwb25zZRJECghzZXR0aW5ncxgBIAMoCzIyLmdycGMuYXBpLnYxLkFjY291bnRTZXR0aW5nc1Jlc3BvbnNlLlNldHRpbmdzRW50cnkaLwoNU2V0dGluZ3NFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIpQBChlTZXRBY2NvdW50U2V0dGluZ3NSZXF1ZXN0EkYKCHNldHRpbmdzGAEgAygLMjQuZ3JwYy5hcGkudjEuU2V0QWNjb3VudFNldHRpbmdzUmVxdWVzdC5TZXR0aW5nc0VudHJ5Gi8KDVNldHRpbmdzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ATKRBAoPU2V0dGluZ3NTZXJ2aWNlEk4KEmdldERlZmF1bHRDYW1wYWlnbhIZLmdycGMuYXBpLnYxLkVtcHR5UmVxdWVzdBodLmdycGMuYXBpLnYxLkNhbXBhaWduUmVzcG9uc2USTwoTdGVzdERlZmF1bHRDYW1wYWlnbhIcLmdycGMuYXBpLnYxLkNhbXBhaWduUmVxdWVzdBoaLmdycGMuYXBpLnYxLkVtcHR5UmVzcG9uc2USVAoVdXBkYXRlRGVmYXVsdENhbXBhaWduEhwuZ3JwYy5hcGkudjEuQ2FtcGFpZ25SZXF1ZXN0Gh0uZ3JwYy5hcGkudjEuQ2FtcGFpZ25SZXNwb25zZRJMCg5saXN0Q3VycmVuY2llcxIZLmdycGMuYXBpLnYxLkVtcHR5UmVxdWVzdBodLmdycGMuYXBpLnYxLkN1cnJlbmN5UmVzcG9uc2UwARJVChJnZXRBY2NvdW50U2V0dGluZ3MSGS5ncnBjLmFwaS52MS5FbXB0eVJlcXVlc3QaJC5ncnBjLmFwaS52MS5BY2NvdW50U2V0dGluZ3NSZXNwb25zZRJiChJzZXRBY2NvdW50U2V0dGluZ3MSJi5ncnBjLmFwaS52MS5TZXRBY2NvdW50U2V0dGluZ3NSZXF1ZXN0GiQuZ3JwYy5hcGkudjEuQWNjb3VudFNldHRpbmdzUmVzcG9uc2VCBloELjtwYmIGcHJvdG8z", [file_empty, file_campaign, file_currency]);

/**
 * @generated from message grpc.api.v1.CampaignRequest
 */
export type CampaignRequest = Message<"grpc.api.v1.CampaignRequest"> & {
  /**
   * @generated from field: grpc.api.v1.Campaign campaign = 1;
   */
  campaign?: Campaign | undefined;
};

/**
 * Describes the message grpc.api.v1.CampaignRequest.
 * Use `create(CampaignRequestSchema)` to create a new message.
 */
export const CampaignRequestSchema: GenMessage<CampaignRequest> = /*@__PURE__*/
  messageDesc(file_settings_service, 0);

/**
 * @generated from message grpc.api.v1.CampaignResponse
 */
export type CampaignResponse = Message<"grpc.api.v1.CampaignResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Campaign campaign = 1;
   */
  campaign?: Campaign | undefined;
};

/**
 * Describes the message grpc.api.v1.CampaignResponse.
 * Use `create(CampaignResponseSchema)` to create a new message.
 */
export const CampaignResponseSchema: GenMessage<CampaignResponse> = /*@__PURE__*/
  messageDesc(file_settings_service, 1);

/**
 * @generated from message grpc.api.v1.CurrencyResponse
 */
export type CurrencyResponse = Message<"grpc.api.v1.CurrencyResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Currency currency = 1;
   */
  currency?: Currency | undefined;
};

/**
 * Describes the message grpc.api.v1.CurrencyResponse.
 * Use `create(CurrencyResponseSchema)` to create a new message.
 */
export const CurrencyResponseSchema: GenMessage<CurrencyResponse> = /*@__PURE__*/
  messageDesc(file_settings_service, 2);

/**
 * @generated from message grpc.api.v1.AccountSettingsResponse
 */
export type AccountSettingsResponse = Message<"grpc.api.v1.AccountSettingsResponse"> & {
  /**
   * @generated from field: map<string, string> settings = 1;
   */
  settings: { [key: string]: string };
};

/**
 * Describes the message grpc.api.v1.AccountSettingsResponse.
 * Use `create(AccountSettingsResponseSchema)` to create a new message.
 */
export const AccountSettingsResponseSchema: GenMessage<AccountSettingsResponse> = /*@__PURE__*/
  messageDesc(file_settings_service, 3);

/**
 * @generated from message grpc.api.v1.SetAccountSettingsRequest
 */
export type SetAccountSettingsRequest = Message<"grpc.api.v1.SetAccountSettingsRequest"> & {
  /**
   * @generated from field: map<string, string> settings = 1;
   */
  settings: { [key: string]: string };
};

/**
 * Describes the message grpc.api.v1.SetAccountSettingsRequest.
 * Use `create(SetAccountSettingsRequestSchema)` to create a new message.
 */
export const SetAccountSettingsRequestSchema: GenMessage<SetAccountSettingsRequest> = /*@__PURE__*/
  messageDesc(file_settings_service, 4);

/**
 * @generated from service grpc.api.v1.SettingsService
 */
export const SettingsService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.SettingsService.getDefaultCampaign
   */
  getDefaultCampaign: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof CampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.SettingsService.testDefaultCampaign
   */
  testDefaultCampaign: {
    methodKind: "unary";
    input: typeof CampaignRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.SettingsService.updateDefaultCampaign
   */
  updateDefaultCampaign: {
    methodKind: "unary";
    input: typeof CampaignRequestSchema;
    output: typeof CampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.SettingsService.listCurrencies
   */
  listCurrencies: {
    methodKind: "server_streaming";
    input: typeof EmptyRequestSchema;
    output: typeof CurrencyResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.SettingsService.getAccountSettings
   */
  getAccountSettings: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof AccountSettingsResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.SettingsService.setAccountSettings
   */
  setAccountSettings: {
    methodKind: "unary";
    input: typeof SetAccountSettingsRequestSchema;
    output: typeof AccountSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_settings_service, 0);

